<div class="search-container">
  <input type="text"
         class="search-input"
         [(ngModel)]="searchText"
         [placeholder]="placeholder"
         (input)="onInput()" />

  <button *ngIf="searchText"
          class="clear-button"
          (click)="clear()"
          aria-label="Clear search">
    <mat-icon>clear</mat-icon>
  </button>
</div>
